import React, { useState, createContext, useContext, useRef } from 'react';
import api from '../services/api';
import { normalizarComanda } from '../utils/dateUtils';

const DataContext = createContext(null);

const CACHE_TTL = 30000;

export const DataProvider = ({ children, usuariosState }) => {
  const [servicos, setServicos] = useState([]);
  const [barbeiros, setBarbeiros] = useState([]);
  const [usuarios, setUsuarios] = usuariosState;
  const [comandas, setComandas] = useState([]);
  const [agendamentos, setAgendamentos] = useState([]);
  const [configuracoes, setConfiguracoes] = useState({ comissaoPadrao: 48 });
  const [disponibilidade, setDisponibilidade] = useState({});
  const lastFetchRef = useRef(0);
  const fetchingRef = useRef(false);

  const carregarDados = React.useCallback(async (force = false) => {
    if (!force && Date.now() - lastFetchRef.current < CACHE_TTL) return;
    if (fetchingRef.current) return;
    fetchingRef.current = true;
    try {
      const [servicosDados, usuariosDados, barbeirosDados, comandasDados, configsDados] = await Promise.all([
        api.servicos.getAll(),
        api.users.getAll(),
        api.barbeiros.getAll(),
        api.comandas.getAll(),
        api.configuracoes.get(),
      ]);
      setServicos(Array.isArray(servicosDados) ? servicosDados.map(s => ({
        ...s, preco: parseFloat(s.preco || 0), ativo: s.ativo !== false
      })) : []);
      setUsuarios(usuariosDados);
      setBarbeiros(barbeirosDados);
      setComandas(comandasDados.map(c => normalizarComanda(c)));
      setConfiguracoes({ comissaoPadrao: parseFloat(configsDados.comissaoPadrao) || 48 });
      lastFetchRef.current = Date.now();
    } catch (error) {
      if (error.isAuthError || error.response?.status === 401) return;
      console.error('Erro ao carregar dados:', error);
    } finally {
      fetchingRef.current = false;
    }
  }, []);

  return (
    <DataContext.Provider value={{
      servicos, setServicos, barbeiros, setBarbeiros,
      comandas, setComandas, agendamentos, setAgendamentos,
      configuracoes, setConfiguracoes, disponibilidade, setDisponibilidade,
      usuarios, setUsuarios, carregarDados
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
